import GameState from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";

export default class HarleyInFreespins extends Decision {
    public evaluate() {
        const record = GameState.getCurrentGame().getCurrentRecord();

        let inFreespins;

        if (record instanceof FreespinRecord) {
            inFreespins = true;
        }

        if (GameState.getCurrentGame().inFreespinsGame) {
            inFreespins = true;
        }

        if (record instanceof FreespinRecord && record.beenPaid) {
            inFreespins = false;
        }

        return inFreespins ? Exit.True : Exit.False;
    }
}
